var exports = {
  "Tj": "xe533113f--45adce--map",
  "_8": "xe533113f--45adce--img",
  "y_": "xe533113f--45adce--pin",
};

module.exports = exports;
